import SideBar from "./SideBar";
import UserCenter from "./UserCenter";

export default SideBar;

export {
    SideBar,
    UserCenter
}


// WEBPACK FOOTER //
// ./src/components/sidebar/index.ts